export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Back to homepage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["홈으로 돌아가기"])}
    }
  })
}
